import api from "api";

const events = {
    get: (grouped, city) => {
        return api().get('/events', {
            params: {
                city: city,
                grouped,
                limit: 500
            }
        })
    },

    filter: (payload) => {
        return api().get('/events', {
            params: { ...payload }
        })
    },

    near: ({ lat, long, page = 1, perPage = 9 }) => {
        return api().get(`/events/near/${Number(lat)}/${Number(long)}/${perPage}?page=${page}`)
    },
    allNears: ({ lat, long }) => {
        return api().get(`/events/near/${Number(lat)}/${Number(long)}`)
    },

    findMultiples: ({ lat, long }) => {
        return api().get(`/events`, {
            params: { lat, long }
        })
    },

    getBySlug: (slug, params = {}) => {
        return api().get(`/events/detail/${slug}`, { params })
    },

    autocomplete: (payload) => {
        return api(false, true).get(`/search/${payload}`);
    },

    create: (payload) => {
        return api().post('/events', payload);
    },
    
    update: (slug, payload) => {
        return api().put(`/events/${slug}`, payload);
    },

    delete: (payload) => {
        return api().delete(`/events/${payload}`);
    },

    myEvents: (params) => {
        return api().get('/events/my-events', {
            params: {...params}
        });
    },

    searchEvents: (payload) => {
        return api().get(`/events/my-events?name=${payload}`);
    },

    deleteMyEvents: (payload) => {
        return api().delete(`/events/${payload}`);
    },

    getByEstablishmentId: (establishmentId) => {
        return api().get(`/establishments/${establishmentId}/events`);
    },

    getActiveLocations: () => {
        return api().get('/events/locations/active');
    },

    interest: (eventSlug, status) => {
        return api().post(`/events/${eventSlug}/interest`, { status });
    },

    getParticipantsPreview: (slug) => {
        return api().get(`/events/detail/${slug}/participants/preview`);
    },

    getParticipantsPublic: (slug) => {
        return api().get(`/events/detail/${slug}/participants/public`);
    },

    getTickets: (slug) => api().get(`/events/detail/${slug}/tickets`),

    getActive: (slug) =>
        api().get(`/establishments/${slug}/pos-events/active`),
};

export default events;  